import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { getRouteApi } from '@tanstack/react-router';
import { SlidersHorizontalIcon } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

import type { ToolbarProps } from './toolbar';

interface FilterButtonProps {
  url: ToolbarProps['url'];
}

export const FilterButton = ({ url }: FilterButtonProps) => {
  const route = getRouteApi(url);
  const [t] = useTranslation();
  const navigate = route.useNavigate();
  const search = route.useSearch();
  const { enableFilters } = useMemo(
    () => ({
      enableFilters: 'enableFilters' in search ? search.enableFilters : undefined,
    }),
    [search]
  );

  const switchEnableFilters = () => {
    navigate({
      search: (prev) => ({
        ...prev,
        enableFilters: 'enableFilters' in prev ? !prev.enableFilters : true,
      }),
      replace: true,
    });
  };

  return (
    <Button
      size="xl"
      variant="outline"
      className={cn(
        'flex justify-center gap-[5px] px-[20px]',
        enableFilters && 'bg-primary-light text-white'
      )}
      onClick={switchEnableFilters}
    >
      <SlidersHorizontalIcon
        className={cn(
          'flex items-center transition-transform motion-reduce:transition-none',
          !enableFilters && 'rotate-180'
        )}
      />
      <span className="block max-xl:hidden">{t('filter')}</span>
    </Button>
  );
};
